"use strict";
// Countdown Timer
(function () {
const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;

const birthday = "12/25/2022";

const countDown = new Date(birthday).getTime(),
      x = setInterval(function() {    

const now = new Date().getTime(),
      distance = countDown - now;
            
    const displayDays = Math.floor(distance / (day)),
          displayHours = Math.floor((distance % (day)) / (hour)),
          displayMins = Math.floor((distance % (hour)) / (minute)),
          displaySecs = Math.floor((distance % (minute)) / second);

    let zeroDigit1, zeroDigit2, zeroDigit3, zeroDigit4;
      if(displayDays<10) {zeroDigit1 = 0;} else {zeroDigit1 = "";}
      if(displayHours<10) {zeroDigit2 = 0;} else {zeroDigit2 = "";}
      if(displayMins<10) {zeroDigit3 = 0;} else {zeroDigit3 = "";}
      if(displaySecs<10) {zeroDigit4 = 0;} else {zeroDigit4 = "";}

                const daysContainer = document.getElementById("rdc-days");
if(daysContainer) {
          daysContainer.innerText = `${zeroDigit1}${Math.floor(distance / (day))}`,
          document.getElementById("rdc-hours").innerText = `${zeroDigit2}${Math.floor((distance % (day)) / (hour))}`,
          document.getElementById("rdc-minutes").innerText = `${zeroDigit3}${Math.floor((distance % (hour)) / (minute))}`,
          document.getElementById("rdc-seconds").innerText = `${zeroDigit4}${Math.floor((distance % (minute)) / second)}`;
}
      }, 0)
  }());


console.log("redr")

// // Yocan Flame Promo
// const flameBtns = document.querySelectorAll('.rdc-flame-2022-atc-btn');
// const flameCoilBtns = document.querySelectorAll('.rdc-flame-2022-atc-btn-c');
// const flameCheckout = document.querySelector('.rdc-flame-d2022-checkout');

// let checkoutURL = "";
// const atcFlame = function () {
//   flameCheckout.href=""; 
//   flameCheckout.classList.add('rdc-disabled');
//     flameCoilBtns.forEach(flameCoilBtn => {
//   flameCoilBtn.classList.remove('rdc-added-to-cart')
// })
//   checkoutURL = `/cart/${this.id}:1`;
//   flameCoilBtns.forEach(flameCoilBtn => {
//   flameCoilBtn.classList.remove('rdc-disabled')
// })
//   flameBtns.forEach(flameBtn => {
//   flameBtn.classList.remove('rdc-added-to-cart')
// })
// this.classList.add('rdc-added-to-cart')
// }

// const atcFlameCoil = function () {
//   if(!this.classList.contains('rdc-disabled')) {   
  
//   let newCheckoutURL = `${checkoutURL},${this.id}:1`
//   flameCheckout.classList.remove('rdc-disabled');
//   flameCoilBtns.forEach(flameCoilBtn => {
//   flameCoilBtn.classList.remove('rdc-added-to-cart')
// })
//   this.classList.add('rdc-added-to-cart')
    
//   flameCheckout.href=`${newCheckoutURL}`; 
//      }
// }


// flameBtns.forEach(flameBtn => {
//   flameBtn.addEventListener('click',atcFlame)
// })

// flameCoilBtns.forEach(flameCoilBtn => {
//   flameCoilBtn.addEventListener('click',atcFlameCoil)
// })



// BFRIDAY 2022

// Game
const gameFields = document.querySelectorAll('.bf-game-input')
const gameSubmit = document.querySelector('.bf-game-lg-btn')
const gameBox = document.querySelector('.bfriday-2022-game-box-outer');
const bfMain = document.querySelector('.bfriday-2022-promo-main')

const correctAns = ['o', 'c']
const answerArr = [];
const answerArrRev = [];
let answerLetter;

  let count = 0;
const recordAnswer = function () {
  console.log(Array.from(gameFields).indexOf(this) != answerArr.length-1)
  if(Array.from(gameFields).indexOf(this) == answerArr.length && answerArrRev.length == 0) {
    answerArr.push(this.value.toLowerCase());
     
      } else if(Array.from(gameFields).indexOf(this) != answerArrRev.length) {
    answerArrRev.push(this.value);
      }
  answerArrRev.reverse()
       console.log(`test ${answerArr}`)
  console.log(`test rev ${answerArrRev}`)


  if(answerArr.length == correctAns.length || answerArrRev.length == correctAns.length) {
for(let i=0; i<correctAns.length; i++) {
  if(correctAns[i] == answerArr[i] || correctAns[i] == answerArrRev[i]) {
    count++
      }
    }
    
  }
  
}
if(gameSubmit) {
       gameSubmit.addEventListener('click', function () {
           if (count==correctAns.length) {
             gameBox.classList.add('rdc-d-none')
             bfMain.classList.remove('rdc-d-none')
             } else {
             this.style.backgroundColor = "#ff4b4b"
             this.innerHTML = "TRY AGAIN"
             }
       })
}

Array.from(gameFields).forEach(gameField => {
  gameField.addEventListener('change', recordAnswer)
})


// Access API to for adding item to cart
const addItemAPI = function (itemData) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(itemData)
})
.then(response => {
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
}

let itemsCount = 0;
const countBubble = document.querySelector(".bfriday-cart-count")

// // Access API to for getting items in cart
// const getCartItems = function () {
//   setTimeout(function () {
//         fetch(window.Shopify.routes.root + 'cart.js')
// .then(response => {return response.json()})
// .then(data => {itemsCount = data.item_count})
//   },300)
// }
const updateCartBubble = function () {
    setTimeout(function () {
        fetch(window.Shopify.routes.root + 'cart.js')
.then(response => {return response.json()})
.then(data => {itemsCount = data.item_count
                countBubble.innerHTML = `${itemsCount}`})
},500)
}

updateCartBubble()


// add to cart
const variantImgs = document.querySelectorAll('.bfriday-2022-variant-img')
const addToCarts = document.querySelectorAll('.bfriday-2022-atc')
const cardImgs = document.querySelectorAll('.bf-22-card-img')

let atcID;
console.log(atcID)

const changeVariant = function () {
  const thisMainParent = this.parentElement.parentElement.parentElement.parentElement;
  atcID = this.getAttribute('data-id')
  thisMainParent.children[0].children[0].src = this.getAttribute('data-img')
}

variantImgs.forEach(variantImg => {
  variantImg.addEventListener('click', changeVariant)
})


const addItemToCart = function () {
  this.innerHTML = 'ADDED'
  this.style.opacity = '.7'

  const self = this;
const changeATCText = function () {
    self.innerHTML = 'ADD TO CART'
  self.style.opacity = '1'
}

  setTimeout(changeATCText,1000)
  
if(atcID == undefined) {
  atcID = this.getAttribute('data-id')
}
console.log(atcID)
  
let itemData = {
 'items': [{
  'id': atcID,
  'quantity': 1
  }]
};
  
addItemAPI(itemData)
updateCartBubble()
}

addToCarts.forEach(addToCart => {
    addToCart.addEventListener('click', addItemToCart)
})



// BFRIDAY 2022 END ---------------------------------------------------------

// console.log(window.location.href)

// if (window.location.href.toString().includes("/collections/vendors?")) {
//   window.location.replace("https://www.yocanvaporizer.com");
// }














